// Rodex Grip — scripts globales de marca
(function () {
  "use strict";

  function enEditor() {
    return !!(window.Shopify && Shopify.designMode);
  }

  function prefiereMenosMovimiento() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function initReveals(root) {
    var els = root.querySelectorAll(".rg-reveal:not([data-rg-init])");
    if (!els.length) return;
    els.forEach(function (el) { el.setAttribute("data-rg-init", "1"); });

    if (enEditor() || prefiereMenosMovimiento() || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("rg-visible"); });
      return;
    }
    var contadores = new WeakMap();
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var grupo = el.closest("[data-rg-stagger]");
        if (grupo) {
          var n = contadores.get(grupo) || 0;
          el.style.setProperty("--rg-i", n);
          contadores.set(grupo, n + 1);
        }
        el.classList.add("rg-visible");
        obs.unobserve(el);
      });
    }, { threshold: 0.16, rootMargin: "0px 0px -6% 0px" });
    els.forEach(function (el) { obs.observe(el); });
  }

  function initCifras(root) {
    var els = root.querySelectorAll("[data-rg-cifra]:not([data-rg-init])");
    if (!els.length) return;
    els.forEach(function (el) { el.setAttribute("data-rg-init", "1"); });

    var anima = function (el) {
      var destino = parseFloat(el.getAttribute("data-rg-cifra"));
      if (isNaN(destino)) return;
      if (prefiereMenosMovimiento() || enEditor()) { el.textContent = destino.toLocaleString("es-ES"); return; }
      var duracion = 1400, inicio = null;
      function paso(ts) {
        if (inicio === null) inicio = ts;
        var progreso = Math.min((ts - inicio) / duracion, 1);
        var actual = Math.round(destino * (1 - Math.pow(1 - progreso, 3)));
        el.textContent = actual.toLocaleString("es-ES");
        if (progreso < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    };
    if (!("IntersectionObserver" in window)) { els.forEach(anima); return; }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { anima(entry.target); obs.unobserve(entry.target); }
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { obs.observe(el); });
  }

  function initAcordeon(root) {
    var items = root.querySelectorAll(".rg-acc-item:not([data-rg-init])");
    if (!items.length) return;
    items.forEach(function (item) {
      item.setAttribute("data-rg-init", "1");
      var btn = item.querySelector(".rg-acc-btn");
      var panel = item.querySelector(".rg-acc-panel");
      if (!btn || !panel) return;
      btn.addEventListener("click", function () {
        var abierto = item.classList.contains("rg-abierto");
        var lista = item.closest(".rg-faq-lista");
        if (lista) {
          lista.querySelectorAll(".rg-acc-item.rg-abierto").forEach(function (otro) {
            if (otro !== item) {
              otro.classList.remove("rg-abierto");
              otro.querySelector(".rg-acc-panel").style.maxHeight = null;
            }
          });
        }
        if (abierto) {
          item.classList.remove("rg-abierto");
          panel.style.maxHeight = null;
        } else {
          item.classList.add("rg-abierto");
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
    });
  }

  function initGaleriaProducto(root) {
    // Delegación de eventos en el contenedor: el tema de Shopify puede volver
    // a renderizar los nodos internos (imagen principal / miniaturas) al
    // sincronizar la variante seleccionada, así que no nos fiamos de
    // referencias cacheadas a esos nodos — las buscamos en cada interacción.
    var galerias = root.querySelectorAll("[data-rg-galeria]:not([data-rg-galeria-ready])");
    galerias.forEach(function (galeria) {
      // Ojo: este contenedor también lleva la clase .rg-reveal, y initReveals()
      // ya marca ese elemento con data-rg-init="1" para su propia comprobación.
      // Si usáramos el mismo atributo aquí, esta función nunca se ejecutaría
      // porque el guardado de arriba ya lo daría por "inicializado". Por eso
      // usamos un atributo propio y exclusivo de esta función.
      galeria.setAttribute("data-rg-galeria-ready", "1");

      function cambiarAMini(mini) {
        if (!mini) return;
        var principal = galeria.querySelector("[data-rg-galeria-principal]");
        var src = mini.getAttribute("data-rg-src");
        var srcset = mini.getAttribute("data-rg-srcset");
        if (!principal || !src) return;
        principal.style.opacity = "0";
        setTimeout(function () {
          principal.setAttribute("src", src);
          if (srcset) principal.setAttribute("srcset", srcset);
          principal.style.opacity = "1";
        }, 160);
        galeria.querySelectorAll("[data-rg-galeria-mini]").forEach(function (m) {
          m.classList.remove("rg-activa");
        });
        mini.classList.add("rg-activa");
        mini.scrollIntoView({ block: "nearest", inline: "center", behavior: "smooth" });
      }

      function ir(direccion) {
        var minisArr = Array.prototype.slice.call(galeria.querySelectorAll("[data-rg-galeria-mini]"));
        if (minisArr.length < 2) return;
        var activa = minisArr.findIndex(function (m) { return m.classList.contains("rg-activa"); });
        if (activa === -1) activa = 0;
        var siguiente = activa + direccion;
        if (siguiente < 0) siguiente = minisArr.length - 1;
        if (siguiente >= minisArr.length) siguiente = 0;
        cambiarAMini(minisArr[siguiente]);
      }

      galeria.addEventListener("click", function (e) {
        var mini = e.target.closest("[data-rg-galeria-mini]");
        if (mini) cambiarAMini(mini);
      });

      var touchStartX = 0;
      var touchStartY = 0;
      var touching = false;
      galeria.addEventListener("touchstart", function (e) {
        if (e.touches.length !== 1 || !e.target.closest("[data-rg-galeria-principal]")) return;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touching = true;
      }, { passive: true });
      galeria.addEventListener("touchend", function (e) {
        if (!touching) return;
        touching = false;
        var touch = e.changedTouches[0];
        var dx = touch.clientX - touchStartX;
        var dy = touch.clientY - touchStartY;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        ir(dx < 0 ? 1 : -1);
      }, { passive: true });
    });
  }

  function initBundleProducto(root) {
    var bundles = root.querySelectorAll("[data-rg-bundle]:not([data-rg-init])");
    bundles.forEach(function (bundle) {
      bundle.setAttribute("data-rg-init", "1");
      var dataEl = bundle.querySelector("[data-rg-bundle-variantes]");
      if (!dataEl) return;
      var variantes;
      try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var tabs = bundle.querySelectorAll("[data-rg-bundle-tab]");
      var boton = bundle.querySelector("[data-rg-bundle-comprar]");
      var precioEl = bundle.querySelector("[data-rg-bundle-precio]");
      var precioComparadoEl = bundle.querySelector("[data-rg-bundle-precio-comparado]");
      var descuentoEl = bundle.querySelector("[data-rg-bundle-descuento]");
      var stickyPrecioEl = document.querySelector("[data-rg-sticky-precio]");
      var cantidadActual = "1";

      function actualizarDescuento() {
        if (!descuentoEl) return;
        var actual = parseFloat((precioEl && precioEl.textContent || "").replace(/[^0-9.]/g, ""));
        var comparadoVisible = precioComparadoEl && precioComparadoEl.style.display !== "none";
        var comparado = parseFloat((comparadoVisible ? precioComparadoEl.textContent : "").replace(/[^0-9.]/g, ""));
        if (!isNaN(actual) && !isNaN(comparado) && comparado > actual) {
          descuentoEl.textContent = "-" + Math.round((1 - actual / comparado) * 100) + "%";
        } else {
          descuentoEl.textContent = "";
        }
      }
      function sincronizarSticky() {
        if (stickyPrecioEl && precioEl) stickyPrecioEl.textContent = precioEl.textContent;
      }

      function variantePorColor(color) {
        return variantes.find(function (v) { return v.color === color; });
      }
      function panelActual() {
        return bundle.querySelector('[data-rg-bundle-panel="' + cantidadActual + '"]');
      }
      function actualizarDisponibilidad() {
        if (!boton) return;
        var panel = panelActual();
        var selects = panel ? panel.querySelectorAll("[data-rg-bundle-color]") : [];
        var disponible = true;
        selects.forEach(function (s) {
          var v = variantePorColor(s.value);
          if (!v || !v.disponible) disponible = false;
        });
        boton.disabled = !disponible;
        boton.textContent = disponible
          ? boton.getAttribute("data-rg-texto-disponible")
          : boton.getAttribute("data-rg-texto-agotado");
      }

      function seleccionarOpcion(tab) {
        cantidadActual = tab.getAttribute("data-rg-bundle-tab");
        tabs.forEach(function (t) { t.classList.remove("rg-activa"); });
        tab.classList.add("rg-activa");
        if (precioEl) precioEl.textContent = tab.getAttribute("data-rg-precio-actual");
        if (precioComparadoEl) {
          var comparado = tab.getAttribute("data-rg-precio-comparado-actual");
          if (comparado) { precioComparadoEl.textContent = comparado; precioComparadoEl.style.display = ""; }
          else { precioComparadoEl.style.display = "none"; }
        }
        actualizarDescuento();
        sincronizarSticky();
        actualizarDisponibilidad();
      }

      tabs.forEach(function (tab) {
        tab.addEventListener("click", function () { seleccionarOpcion(tab); });
        tab.addEventListener("keydown", function (e) {
          if (e.key === "Enter" || e.key === " ") {
            if (e.target === tab) { e.preventDefault(); seleccionarOpcion(tab); }
          }
        });
      });

      bundle.querySelectorAll("[data-rg-bundle-color]").forEach(function (select) {
        select.addEventListener("change", actualizarDisponibilidad);
      });

      if (boton) {
        boton.addEventListener("click", function () {
          var panel = panelActual();
          if (!panel) return;
          var items = [];
          panel.querySelectorAll("[data-rg-bundle-color]").forEach(function (select) {
            var v = variantePorColor(select.value);
            if (v) items.push({ id: v.id, quantity: 1 });
          });
          if (!items.length) return;
          var textoOriginal = boton.textContent;
          boton.disabled = true;
          boton.textContent = "Adding...";
          var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
          fetch(base + "cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ items: items })
          })
            .then(function (res) {
              if (!res.ok) return res.json().then(function (data) { throw new Error(data.description || "error"); });
              return res.json();
            })
            .then(function () {
              window.location.href = base + "cart";
            })
            .catch(function () {
              boton.disabled = false;
              boton.textContent = textoOriginal;
              window.alert("We couldn't add this to your cart. Please try again.");
            });
        });
      }

      actualizarDescuento();
      sincronizarSticky();
      actualizarDisponibilidad();
    });
  }

  function initBarraSticky(root) {
    var barras = root.querySelectorAll("[data-rg-barra-sticky]:not([data-rg-sticky-ready])");
    barras.forEach(function (barra) {
      barra.setAttribute("data-rg-sticky-ready", "1");
      var contenedor = barra.parentElement || document;
      var botonReal = contenedor.querySelector("[data-rg-bundle-comprar]");
      var botonSticky = barra.querySelector("[data-rg-sticky-comprar]");
      if (!botonReal || !botonSticky) return;
      botonSticky.addEventListener("click", function () { botonReal.click(); });
      if (!("IntersectionObserver" in window)) return;
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var yaPasado = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          barra.classList.toggle("rg-visible", yaPasado);
        });
      }, { threshold: 0 });
      obs.observe(botonReal);
    });
  }

  function initResenaFotos(root) {
    var grupos = root.querySelectorAll("[data-rg-resena-fotos]:not([data-rg-resena-fotos-ready])");
    grupos.forEach(function (grupo) {
      grupo.setAttribute("data-rg-resena-fotos-ready", "1");
      var fotos = Array.prototype.slice.call(grupo.querySelectorAll("[data-rg-resena-foto]"));
      var dots = Array.prototype.slice.call(grupo.querySelectorAll(".rg-resena__dot"));
      if (fotos.length < 2) return;

      function mostrar(idx) {
        fotos.forEach(function (f, i) { f.classList.toggle("rg-activa", i === idx); });
        dots.forEach(function (d, i) { d.classList.toggle("rg-activa", i === idx); });
      }

      var touchStartX = 0;
      var touching = false;
      grupo.addEventListener("touchstart", function (e) {
        if (e.touches.length !== 1) return;
        touchStartX = e.touches[0].clientX;
        touching = true;
      }, { passive: true });
      grupo.addEventListener("touchend", function (e) {
        if (!touching) return;
        touching = false;
        var dx = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(dx) < 30) return;
        var activa = fotos.findIndex(function (f) { return f.classList.contains("rg-activa"); });
        mostrar(dx < 0 ? (activa + 1) % fotos.length : (activa - 1 + fotos.length) % fotos.length);
      }, { passive: true });
    });
  }

  function initColorSwatches(root) {
    var grupos = root.querySelectorAll("[data-rg-swatch-group]:not([data-rg-swatch-ready])");
    grupos.forEach(function (grupo) {
      grupo.setAttribute("data-rg-swatch-ready", "1");
      var select = grupo.parentElement.querySelector("[data-rg-bundle-color]");
      if (!select) return;
      grupo.addEventListener("click", function (e) {
        var swatch = e.target.closest("[data-rg-swatch-value]");
        if (!swatch) return;
        select.value = swatch.getAttribute("data-rg-swatch-value");
        select.dispatchEvent(new Event("change", { bubbles: true }));
        grupo.querySelectorAll("[data-rg-swatch-value]").forEach(function (s) {
          s.classList.remove("rg-activa");
        });
        swatch.classList.add("rg-activa");
      });
    });
  }

  function initTilt(root) {
    var els = root.querySelectorAll("[data-rg-tilt]:not([data-rg-init])");
    if (!els.length || matchMedia("(pointer: coarse)").matches) return;
    els.forEach(function (el) {
      el.setAttribute("data-rg-init", "1");
      el.addEventListener("mousemove", function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        el.style.transform = "perspective(800px) rotateY(" + (x * 6) + "deg) rotateX(" + (y * -6) + "deg) translateY(-4px)";
      });
      el.addEventListener("mouseleave", function () { el.style.transform = ""; });
    });
  }

  function initTodo(root) {
    root = root || document;
    initReveals(root);
    initCifras(root);
    initAcordeon(root);
    initGaleriaProducto(root);
    initBundleProducto(root);
    initColorSwatches(root);
    initResenaFotos(root);
    initBarraSticky(root);
    initTilt(root);
  }

  document.addEventListener("DOMContentLoaded", function () {
    initTodo(document);
  });

  // El editor de temas de Shopify sustituye el HTML de una sección por AJAX
  // cada vez que se cambia un ajuste, SIN recargar la página. Sin esto, la
  // sección editada se queda con la animación de aparición a medias (invisible)
  // porque nuestros observadores solo se crearon una vez, al cargar la página.
  document.addEventListener("shopify:section:load", function (event) {
    initTodo(event.target);
  });
})();
